// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hj2P","label":"styles_label__3xtnu"};